export default __webpack_public_path__ + "static/media/mainLogo.f94fe30e.svg";